import PocketBase from 'pocketbase';

const {REACT_APP_POCKETBASE} = process.env

export const pb = new PocketBase("https://pocketbase.flexipgroup.com");